export default __webpack_public_path__ + "static/media/danskeheadline-webfont.f1c3b621.ttf";